import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    actionsNewLine: boolean | undefined;
    isLayoutMobile: boolean;
  }>()
  .create(({ theme, actionsNewLine, isLayoutMobile }) => ({
    header: {
      backgroundColor: theme.vars.palette.background.elevation1,
      borderBottom: `0.0625rem solid ${theme.vars.palette.border.light}`,
      boxShadow: theme.shadows[2],
      zIndex: 2
    },
    headerInner: {
      alignItems: actionsNewLine && isLayoutMobile ? 'start' : 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(2, 3)
    }
  }));

export default useStyles;
